/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row2_MulticaInputs */

const en_mk_cmp_row2_multica = /** @type {(inputs: Mk_Cmp_Row2_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering / coding-agent teams`)
};

const id_mk_cmp_row2_multica = /** @type {(inputs: Mk_Cmp_Row2_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim engineering / coding agent`)
};

/**
* | output |
* | --- |
* | "Engineering / coding-agent teams" |
*
* @param {Mk_Cmp_Row2_MulticaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row2_multica = /** @type {((inputs?: Mk_Cmp_Row2_MulticaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row2_MulticaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row2_multica(inputs)
	return en_mk_cmp_row2_multica(inputs)
});